module.exports = __webpack_public_path__ + "static/media/talk04_small.2dfa2475.jpg";